import { render } from "./SpinnerLoader.vue?vue&type=template&id=ff430c14&scoped=true"
const script = {}

import "./SpinnerLoader.vue?vue&type=style&index=0&id=ff430c14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff430c14"]])

export default __exports__